import { DataStorage } from '@studyportals/data-storage';
import store from '..';

export class DataStorageSyncPlugin {
	public initiate(): void {
		this.syncGlobalAccessInitiativeQuestionnaireStatus();
	}

	private syncGlobalAccessInitiativeQuestionnaireStatus(): void {
		const storageKey = 'global_access_initiative_questionnaire_taken';
		store.mutations.setGAIQuestionnaireTaken(DataStorage.retrieve(storageKey) === 'true');
	}
}
